<header class="position-fixed top-0 start-0">
    <div
        class="header-container mx-auto d-flex justify-content-between align-items-center position-relative w-100"
    >
        <div class="logo">
            <a [routerLink]="'/' | formatUrl | async">
                <img
                    [src]="'vg/images/logo-header.svg' | cdn"
                    alt=""
                    class="logo-desk"
            /></a>
            <a [routerLink]="'/' | formatUrl | async">
                <img
                    [src]="'vg/images/logo-header.svg' | cdn"
                    alt=""
                    class="logo-mob"
            /></a>
        </div>
        <div class="user-options d-flex align-items-stretch">
            <div
                class="gift d-flex align-items-center"
                [routerLink]="'/' | formatUrl | async"
            >
                <img
                    [src]="'vg/images/gift.svg' | cdn"
                    alt=""
                    class="gift-icon"
                />
            </div>
            <div
                class="currency d-flex align-items-center ignore-element-outside"
                (click)="showUserSettings()"
                (keyup.escape)="showUserSettings()"
                tabindex="0"
            >
                <img
                    [src]="
                        (currentLanguage === 'es-mx'
                            ? 'vg/images/emojione_flag-for-mexico.svg'
                            : 'vg/images/Fill.svg'
                        ) | cdn
                    "
                    alt=""
                    class="currency-icon"
                />
                <span class="font-family-lato">MXN</span>
            </div>
            <div
                [ngClass]="{ maintenance_status: maintenance_status }"
                (click)="triggerLogin()"
                (keyup.enter)="triggerLogin()"
                aria-hidden="true"
                class="user d-flex align-items-center justify-content-center ignore-element-outside"
            >
                <vg-spinner *ngIf="isLoading"></vg-spinner>
                <ng-container *ngIf="!isLoading">
                    <img
                        [src]="'vg/images/fa-solid_user.svg' | cdn"
                        alt=""
                        class="user-icon"
                    />
                    <span class="font-family-lato">
                        {{ (user$ | async)?.name }}
                    </span>
                </ng-container>
            </div>
        </div>

        <div
            [ngClass]="{ 'd-none': !showSettings }"
            (vgClickOutside)="onClickOutside()"
            class="user-settings position-absolute end-0"
        >
            <button
                type="button"
                class="position-absolute border-0 d-flex justify-content-center p-0"
            >
                <img
                    [src]="'vg/images/close-gray.svg' | cdn"
                    alt=""
                    (click)="showUserSettings()"
                    (keyup.escape)="showUserSettings()"
                    tabindex="0"
                />
            </button>
            <div class="language-settings d-flex flex-column">
                <div class="country d-flex align-items-center">
                    <img [src]="'vg/images/language.svg' | cdn" alt="" />
                    <span class="fw-bold">{{
                        'vg_header_settings_span_country' | translate
                    }}</span>
                </div>
                <div
                    (click)="onClickChangeLang('es-mx')"
                    (keydown)="onClickChangeLang('es-mx')"
                    tabindex="1"
                    [ngClass]="currentLanguage === 'es-mx' ? 'selected' : ''"
                    class="language d-flex justify-content-between align-items-center"
                >
                    <span class="fs-6 fw-bold">Español - MXN</span>
                    <img
                        [src]="'vg/images/emojione_flag-for-mexico.svg' | cdn"
                        alt=""
                    />
                </div>
                <div
                    (click)="onClickChangeLang('en-us')"
                    (keydown)="onClickChangeLang('en-us')"
                    tabindex="2"
                    [ngClass]="currentLanguage === 'en-us' ? 'selected' : ''"
                    class="language d-flex justify-content-between align-items-center"
                >
                    <span class="fw-bold">Inglés - EUA</span>
                    <img [src]="'vg/images/Fill.svg' | cdn" alt="" />
                </div>
            </div>
            <div class="coin-settings d-flex flex-column">
                <div class="coin d-flex align-items-center">
                    <img [src]="'vg/images/dollar-sign.svg' | cdn" alt="" />
                    <span class="fw-bold">{{
                        'vg_header_settings_span_currency' | translate
                    }}</span>
                </div>
                <div
                    class="currency-set d-flex justify-content-between align-items-center"
                >
                    <span class="selected fs-6 fw-bold">Peso Mexicano</span
                    ><span class="currency-selected">MXN</span>
                </div>
            </div>
        </div>

        <div
            [ngClass]="{ 'd-none': !showLogout }"
            (vgClickOutside)="onClickOutside()"
            class="logout-settings position-absolute end-0"
        >
            <button
                type="button"
                class="position-absolute border-0 d-flex justify-content-center p-0"
            >
                <img
                    [src]="'vg/images/close-gray.svg' | cdn"
                    alt=""
                    (click)="showLogoutSettings()"
                    (keyup.escape)="showLogoutSettings()"
                    tabindex="0"
                />
            </button>
            <div class="info-settings d-flex flex-column">
                <div
                    tabindex="1"
                    class="info d-flex justify-content-between align-items-center"
                >
                    <span
                        class="fs-6 fw-bold"
                        [routerLink]="'/dashboard/home' | formatUrl | async"
                        >Dashboard</span
                    >
                </div>
                <div
                    (click)="onLogOut($event)"
                    (focus)="onLogOut($event)"
                    (keypress)="onLogOut($event)"
                    class="info d-flex justify-content-between align-items-center"
                    aria-hidden="true"
                >
                    <span class="fs-6 fw-bold">{{
                        'vg_header_settings_span_logout' | translate
                    }}</span>
                </div>
            </div>
        </div>
    </div>
</header>
